<template>
	<div>
		<svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12.5 0.78125C7.7538 0.78125 3.90625 4.6288 3.90625 9.375C3.90625 12.5529 5.63158 15.3269 8.19287 16.813C8.90689 17.2273 9.35401 17.8629 9.37425 18.5027C9.38541 18.8555 9.63184 19.1571 9.97542 19.2383C10.3414 19.3248 10.7144 19.3929 11.0933 19.4415C11.4304 19.4849 11.7189 19.2148 11.7189 18.875V14.0197C11.3864 13.9829 11.0604 13.9229 10.743 13.8412C10.3251 13.7336 10.0735 13.3077 10.1811 12.8899C10.2886 12.472 10.7146 12.2205 11.1324 12.328C11.5687 12.4403 12.0268 12.5002 12.5002 12.5002C12.9735 12.5002 13.4317 12.4403 13.868 12.328C14.2858 12.2205 14.7117 12.472 14.8193 12.8899C14.9268 13.3077 14.6753 13.7336 14.2574 13.8412C13.9399 13.9229 13.614 13.9829 13.2814 14.0197V18.8749C13.2814 19.2148 13.57 19.4848 13.9071 19.4415C14.2858 19.3928 14.6587 19.3247 15.0246 19.2383C15.3682 19.1571 15.6146 18.8555 15.6258 18.5027C15.646 17.8629 16.0931 17.2273 16.8071 16.813C19.3684 15.3269 21.0938 12.5529 21.0938 9.375C21.0938 4.6288 17.2462 0.78125 12.5 0.78125Z"
				:fill="color" 
			/>
			<path fill-rule="evenodd" clip-rule="evenodd"
				d="M9.38869 20.7288C9.4691 20.3049 9.87794 20.0264 10.3019 20.1068C11.0133 20.2418 11.748 20.3125 12.5 20.3125C13.252 20.3125 13.9867 20.2418 14.6982 20.1068C15.1221 20.0264 15.5309 20.3049 15.6113 20.7288C15.6917 21.1527 15.4133 21.5616 14.9894 21.642C14.1824 21.795 13.3502 21.875 12.5 21.875C11.6498 21.875 10.8176 21.795 10.0106 21.642C9.58674 21.5616 9.30827 21.1527 9.38869 20.7288Z"
				:fill="color" 
			/>
			<path fill-rule="evenodd" clip-rule="evenodd"
				d="M10.1605 23.275C10.2054 22.8458 10.5897 22.5343 11.0188 22.5792C11.5053 22.6301 11.9995 22.6563 12.5 22.6563C13.0005 22.6563 13.4947 22.6301 13.9812 22.5792C14.4103 22.5343 14.7946 22.8458 14.8395 23.275C14.8844 23.7041 14.5729 24.0884 14.1438 24.1333C13.6033 24.1898 13.0549 24.2188 12.5 24.2188C11.9451 24.2188 11.3967 24.1898 10.8562 24.1333C10.4271 24.0884 10.1156 23.7041 10.1605 23.275Z"
				:fill="color" 
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgBulb',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped>

</style>